import { ChevronRightIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { SpectatorIcon } from 'src/features/business/icons/spectator-icon'
import type { BusinessSummaryItem } from 'src/features/business/shared/schemas/business-item'
import { TeamRole } from 'src/features/team-invitations/schemas/team'

import useSearchMenuActiveStore from '../store/search-menu-active-store'

type FacelessBusinessSearchResultItemProps = {
  business: BusinessSummaryItem
}

const FacelessBusinessSearchResultItem = ({ business }: FacelessBusinessSearchResultItemProps) => {
  const isSpectator = business.viewerRole ? business.viewerRole === TeamRole.SPECTATOR : false
  const { setIsFocused } = useSearchMenuActiveStore()
  const locationText = business.locationText?.[0] || ''

  const onClick = () => {
    setIsFocused(false)
  }

  return (
    <Link onClick={onClick} to={paths.business.singular.getHref(business.id.toString())} state={{ from: 'search' }}>
      <div className="flex flex-row items-center justify-between gap-2">
        <div className="flex flex-row items-center gap-2.5">
          <div
            className="flex size-[40px] items-center justify-center rounded-full border-2 border-white bg-white"
            style={{
              boxShadow: '0px 0px 10px 0px rgba(27,48,41,0.10)',
              backgroundColor: business.consumerColor || '#efefef',
            }}
          >
            <p className="line-clamp-1 text-[15px] font-semibold uppercase text-primary">
              {[business.consumerFirstName?.charAt(0), business.consumerLastName?.charAt(0)].filter(Boolean).join('')}
            </p>
          </div>
          <div className="line-clamp-1 flex flex-col">
            <div className="flex flex-row items-center gap-1">
              <p className="text-sm font-semibold text-primary">
                {[business.consumerFirstName, business.consumerLastName].filter(Boolean).join(' ')}
              </p>
              <span className="text-xs text-muted">
                {isSpectator ? <SpectatorIcon size={16} className="text-muted" /> : null}
              </span>
            </div>
            <p className="text-xs text-muted">{locationText || 'No location'}</p>
          </div>
        </div>
        <span className="text-[13px] text-muted">
          <ChevronRightIcon size={16} />
        </span>
      </div>
    </Link>
  )
}

export default FacelessBusinessSearchResultItem
